import React from 'react';
import PropTypes from 'prop-types';
import { notification, Upload } from 'antd';
import { PlusCircleFilled, CameraFilled, LoadingOutlined } from '@ant-design/icons';
import Button from '../../Button';
import { resizeImage, uploadToGoogleCloud } from '../../../utils/upload';
import styles from './styles.less';

const ImageUpload = ({ uploadHandler, text, multiple, className, type, folder, school, name }) => {
  const [loading, setLoading] = React.useState(false);

  let buttonText;

  if (loading && school) {
    buttonText = <LoadingOutlined />;
  } else if (loading && !school) {
    buttonText = (
      <div className={styles.courseUpload}>
        <LoadingOutlined />
      </div>
    );
  } else if (!loading && school) {
    buttonText = <PlusCircleFilled style={{ fontSize: '20px' }} />;
  } else {
    buttonText = (
      <div className={styles.courseUpload}>
        <CameraFilled style={{ fontSize: '22px' }} />
      </div>
    );
  }

  return (
    <div name={name}>
      <Upload
        multiple={multiple}
        accept="image/*"
        showUploadList={false}
        //  className={[styles.upload, containerClassName].join(' ')}
        customRequest={({ file }) => {
          setLoading(true);
          resizeImage({
            maxWidth: 800,
            file,
          })
            .then(({ file: res }) => {
              uploadToGoogleCloud(type, folder, res)
                .then(url => {
                  uploadHandler(url);
                  setLoading(false);
                })
                .catch(() => {
                  notification.error({
                    message: 'Something went wrong, please try later.',
                  });
                  setLoading(false);
                });
            })
            .catch(() => {
              notification.error({
                message: 'Something went wrong, please try later.',
              });
              setLoading(false);
            });
        }}
      >
        <Button version="large" type="primary" className={className} id="upload">
          {buttonText}
          {text ? <span>{text}</span> : null}
        </Button>
      </Upload>
    </div>
  );
};

ImageUpload.propTypes = {
  text: PropTypes.string,
  type: PropTypes.string,
  multiple: PropTypes.bool,
  folder: PropTypes.string,
  className: PropTypes.string,
  uploadHandler: PropTypes.func.isRequired,
  school: PropTypes.bool,
  name: PropTypes.string,
};

ImageUpload.defaultProps = {
  text: '',
  className: '',
  type: 'school',
  multiple: false,
  folder: 'course',
  school: false,
  name: '',
};

export default ImageUpload;
